// src/organization.ts
function getCurrentOrganizationMembership(organizationMemberships, organizationId) {
  return organizationMemberships.find(
    (organizationMembership) => organizationMembership.organization.id === organizationId
  );
}

export {
  getCurrentOrganizationMembership
};
//# sourceMappingURL=chunk-IBXKDGSZ.mjs.map